const SPANISH_COUNTRIES = new Set([
  "AR",
  "BO",
  "CL",
  "CO",
  "CR",
  "CU",
  "DO",
  "EC",
  "ES",
  "GT",
  "HN",
  "MX",
  "NI",
  "PA",
  "PE",
  "PR",
  "PY",
  "SV",
  "UY",
  "VE",
  "GQ",
]);

const STORAGE_KEY = "i18nextLng";
let geoDetectionInProgress = false;

export function initGeoLanguageDetection(i18nInstance) {
  if (typeof window === "undefined") return;
  if (geoDetectionInProgress) return;

  const pathLangMatch = window.location.pathname.match(/^\/(es|en)(\/|$)/i);
  if (pathLangMatch) return;

  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored) return;

  geoDetectionInProgress = true;

  fetch("https://ipapi.co/json/")
    .then((response) => {
      if (!response.ok) throw new Error("Geo request failed");
      return response.json();
    })
    .then((data) => {
      const country = data?.country_code?.toUpperCase();
      if (!country) return;

      const preferredLanguage = SPANISH_COUNTRIES.has(country) ? "es" : "en";
      if (i18nInstance.language !== preferredLanguage) {
        i18nInstance.changeLanguage(preferredLanguage);
      }
      window.localStorage.setItem(STORAGE_KEY, preferredLanguage);
    })
    .catch(() => {
      // Ignore failures; fallback language already configured.
    })
    .finally(() => {
      geoDetectionInProgress = false;
    });
}

